import type { Directive } from 'vue'
import { trackEvent } from '@/core/matomo'

type Params =
  Parameters<typeof trackEvent> extends [unknown, ...infer Rest] ? Rest : never

function addListener(el: any, params: Params | undefined) {
  if (!params) {
    return
  }

  el.trackMatomoClick = () => trackEvent('CTA', ...params)
  el.addEventListener('click', el.trackMatomoClick)
}

function removeListener(el: any) {
  el.removeEventListener('click', el.trackMatomoClick)
  delete el.trackMatomoClick
}

export const trackMatomoClickDirective: Directive<any, Params | undefined> = {
  beforeMount(el, binding) {
    addListener(el, binding.value)
  },
  updated(el, binding) {
    removeListener(el)
    addListener(el, binding.value)
  },
  unmounted(el) {
    removeListener(el)
  },
}
